/**
 * 台风服务实现类
 */
const ITyphoonForecastService = require('../../ITyphoonForecastService');
/**
 * @classdesc 台风预测服务接口
 * @alias G.service.TyphoonForecastServiceImpl
 * @augments G.service.ITyphoonForecastService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.realtimeUrl {String} 实时台风服务地址
 * @param opts.historyUrl {String} 历史信息时间序列服务地址
 * @param opts.detailUrl {String} 指定时间台风服务地址
 */
class TyphoonForecastServiceImpl extends ITyphoonForecastService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 获取台风实时信息
     * @inheritdoc
     */
    getForecastRealtime(opts) {      
        return new Promise(async(resolve, reject) => {
            try {
                let url = this.opts.realtimeUrl;
                let data = null;
                var self = this;                
                if (!url) {
                    resolve(data);
                }
                for (let k in opts) {
                    url = url.replace('{' + k + '}', opts[k]);
                }
                data = await this.opts.httpRequest.get(url);
                resolve(data);    
            } catch (e) {
                reject(e);
            }
        });        
    }

    /**
     * 获取台风信息时间序列
     * @inheritdoc
     */
    getForecastTimeline(opts) {    
        return new Promise(async(resolve, reject) => {
            try {
                let url = this.opts.historyUrl;
                let data = null;
                var self = this;                
                if (!url) {
                    resolve(data);
                }
                for (let k in opts) {
                    url = url.replace('{' + k + '}', opts[k]);
                }
                data = await this.opts.httpRequest.get(url);
                resolve(data);    
            } catch (e) {
                reject(e);
            }
        });        
    }    
    
    /**
     * 获取台风某时间点信息
     * @inheritdoc
     */
    getForecastByTime(opts) {    
        return new Promise(async(resolve, reject) => {
            try {
                let url = this.opts.detailUrl;
                let data = null;
                var self = this;                
                if (!url) {
                    resolve(data);
                }
                // if (!opts.contentTime) {
                //     opts.contentTime = opts.time;
                // }
                for (let k in opts) {
                    url = url.replace('{' + k + '}', opts[k]);
                }
                data = await this.opts.httpRequest.get(url);
                resolve(data);    
            } catch (e) {
                reject(e);
            }
        });        
    } 
}
module.exports = TyphoonForecastServiceImpl;